import React from 'react';
import AssetWrapper, { AssetWrapperProps } from 'src/app/atoms/Asset/AssetWrapper';
import { VisibilityProps } from 'src/app/atoms/Layout/Visibility.styles';
import { componentPropsToStyledProps } from 'src/app/styles/helper';
import { AbsolutePositionedAssetContainer } from './AbsolutePositionedAsset.styles';
import FillSpace, { FillSpaceProps } from 'src/app/molecules/FillSpace/FillSpace';

interface PositionProps {
  left?: string | number;
  right?: string | number;
  top?: string | number;
  bottom?: string | number;
}

export interface AbsolutePositionedAssetProps extends AssetWrapperProps, VisibilityProps {
  position: PositionProps;
  maxWidth?: string | number;
  width?: string | number;
  zIndex?: number;
  fillSpaceProps?: FillSpaceProps;
}

const AbsolutePositionedAsset = ({
  position,
  maxWidth,
  width,
  zIndex,
  fillSpaceProps,
  hideOn,
  showOn,
  overflow,
  ...assetWrapperProps
}: AbsolutePositionedAssetProps): JSX.Element => {
  const visibilityProps: VisibilityProps = {
    hideOn,
    showOn,
    overflow,
  };

  const absoluteAsset = (
    <AbsolutePositionedAssetContainer
      $position={position}
      $maxWidth={maxWidth}
      $width={width}
      $zIndex={zIndex}
      {...componentPropsToStyledProps(visibilityProps)}
    >
      <AssetWrapper {...assetWrapperProps} />
    </AbsolutePositionedAssetContainer>
  );

  if (fillSpaceProps) {
    return (
      <FillSpace
        position='relative'
        {...fillSpaceProps}
      >
        {absoluteAsset}
      </FillSpace>
    );
  }

  return absoluteAsset;
};

export default AbsolutePositionedAsset;
